// Vendor Libs
import 'react-hot-loader';
import React from 'react';
import {render} from 'react-dom';

// Components
import App from './app';

render(<App />, document.getElementById('app'));
